import store from "../store";

export default {
    data() {
        return {
            addingToCart: false,
        };
    },

    computed: {
        productUrl() {
            if (this.product.url) {
                return this.product.url;
            }

            if (this.product.slug) {
                return route("products.show", { slug: this.product.slug });
            }

            return route("products.index");
        },

        hasAnyOption() {
            return this.product.options_count > 0;
        },

        hasAnyVariant() {
            return this.product.variant_count > 0;
        },

        reviewCount() {
            if (typeof this.product.reviews_count === "number") {
                return this.product.reviews_count;
            }

            if (Array.isArray(this.product.reviews)) {
                return this.product.reviews.length;
            }

            return 0;
        },

        hasNoOption() {
          console.log(this.product.options);
            return !this.hasAnyOption;
        },

        hasBaseImage() {
            if (!this.product.base_image) {
                return false;
            }

            return !!(
                this.product.base_image.path ||
                this.product.base_image.small ||
                this.product.base_image.medium ||
                this.product.base_image.large
            );
        },

        hasBaseImageUrl() {
            return this.base_image.length !== 0;
        },

        baseImage() {
            if (this.hasBaseImage) {
                return (
                    this.product.base_image.path ||
                    this.product.base_image.small ||
                    this.product.base_image.medium ||
                    this.product.base_image.large
                );
            }

            return `${window.Shop.baseUrl}/themes/storefront/public/images/image-placeholder.png`;
        },

        inWishlist() {
            return false; //store.inWishlist(this.product.id);
        },

        inCompareList() {
            return false; //store.inCompareList(this.product.id);
        },
    },

    methods: {
        syncWishlist() {
            store.syncWishlist(this.product.id);
        },

        syncCompareList() {
            store.syncCompareList(this.product.id);
        },

        addToCart() {
            this.addingToCart = true;

            $.ajax({
                method: "POST",
                url: route("cart.items.store", {
                    product_id: this.product.id,
                    qty: 1,
                }),
            })
                .then((cart) => {
                    store.updateCart(cart);

                    if (document.location.href !== route("cart.index")) {
                        if (!$('.cart-wrapper').hasClass('open')) {
                          $(".open-cart").trigger("click");
                        }
                    }
                })
                .catch((xhr) => {
                    this.$notify(xhr.responseJSON.message);
                })
                .always(() => {
                    this.addingToCart = false;
                });
        },
    },
};
